// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9afe920c","754":"82116b2f","939":"7d23fab4"}[chunkId] + ".chunk.js";
};